import { RT_API_LIST } from 'src/store/ActionTypes';

export const fetchApiKey = () => ({
  type: RT_API_LIST.FETCH_API_KEY,
});

/**
 * approveConfig - Approve a realtime API config
 * @param id {string} - the ID of the realtime config to approve
 * @returns {{payload: string, type: string}}
 */
export const approveConfig = (id) => ({
  type: RT_API_LIST.APPROVE_CONFIG,
  payload: id,
});

/**
 * createConfig - Create a realtime API config
 * @param payload {CS} - the new CS
 * @returns {{payload: CS, type: string}}
 */
export const createConfig = (payload) => ({
  type: RT_API_LIST.CREATE_CONFIG,
  payload,
});

/**
 * deleteConfig - Delete a realtime API config
 * @param id {string} - the ID of the realtime config to delete
 * @returns {{payload: string, type: string}}
 */
export const deleteConfig = (id) => ({
  type: RT_API_LIST.DELETE_CONFIG,
  payload: id,
});

/**
 * editConfig - Edit a realtime API config
 * @param id {string} - the ID of the realtime config to update
 * @param update {object} - the key:value pairs of columns to update
 * @returns {{payload: object, type: string}}
 */
export const editConfig = (id, update) => ({
  type: RT_API_LIST.EDIT_CONFIG,
  payload: {
    update,
    id,
  },
});

/**
 * fetchConfigList - Fetch a list of realtime API configs
 * @param payload {string} - querystring for a config list
 * @returns {{payload: string, type: string}}
 */
export const fetchConfigList = (payload) => ({
  type: RT_API_LIST.FETCH_CONFIG_LIST,
  payload,
});

/**
 * selectRow - select a row in the list
 * @param row {object}
 * @return {{payload: object, type: string}}
 */
export const selectRow = (row) => ({
  type: RT_API_LIST.SELECT_ROW,
  payload: row,
});

/**
 * deselectRow - select a row in the list
 * @param row {object}
 * @return {{payload: object, type: string}}
 */
export const deselectRow = (row) => ({
  type: RT_API_LIST.DESELECT_ROW,
  payload: row,
});

/**
 * setGridState - set the state of the table
 * @param state {object} - the next state of the table
 * @return {{payload: object, type: string}}
 */
export const setGridState = (state) => ({
  type: RT_API_LIST.SET_GRID_STATE,
  payload: state,
});

/**
 * deselectAllConfigIds - Deselect all rows in the table by config ID
 * @return {{type: string}}
 */
export const deselectAllConfigIds = () => ({
  type: RT_API_LIST.DESELECT_ALL_ROWS,
});

/**
 * unset - Reset a redux state key to its default
 * @param key {string} the state key to reset
 * @returns {{payload: string, type: string}}
 */
export const unset = (key) => ({
  type: RT_API_LIST.UNSET,
  payload: key,
});

export const fetchModels = (query) => ({
  type: RT_API_LIST.FETCH_MODELS,
  payload: query,
});
